




















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { takeMixin } from "./takeMixin";
@Component({})
export default class Name extends mixins(takeMixin) {
  startTakePhoto() {
    this.takePhoto().then(() => {
      const loading = this.$loading({
        lock: true,
        text: "图片上传中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      this.upload(this.imgData[this.imgData.length - 1]).then(() => {
        loading.close();
        this.readying = false;
        this.filming = false;
      });
    });
  }
  goNext() {
    this.resetCamera();
    this.startCamera();
  }
  private mounted() {
    // this.getCameraDevices();
  }
}
